import { Button, type ButtonProps } from 'antd';
import classnames from 'classnames';
import React, { memo } from 'react';
import { useMediaQuery } from 'react-responsive';

import { LEGACY_MAX_WIDTH_TABLET_MEDIUM } from 'style/constants';

import './styles.less';

// ==============================
// CONSTANTS & PURE FUNCTIONS
// ==============================
const mapTypeToAntdType = (type: Props['type']): ButtonProps['type'] => {
  switch (type) {
    case 'lets-go':
      return 'primary';
    default:
      return type;
  }
};

// ==============================
// TYPES
// ==============================
interface Props
  extends Pick<
    ButtonProps,
    | 'id'
    | 'block'
    | 'children'
    | 'className'
    | 'disabled'
    | 'download'
    | 'href'
    | 'htmlType'
    | 'icon'
    | 'loading'
    | 'onClick'
    | 'rel'
    | 'size'
    | 'target'
  > {
  type?: ButtonProps['type'] | 'lets-go';
  mobileChildren?: string;
}

// ==============================
// COMPONENT
// ==============================
/**
 * A wrapper around the antd Button with our custom config applied.
 */
function DefaultButton({
  children,
  className,
  mobileChildren,
  type,
  ...rest
}: Props): JSX.Element {
  const isTabletOrMobile = useMediaQuery({ maxWidth: LEGACY_MAX_WIDTH_TABLET_MEDIUM });

  return (
    <Button
      {...rest}
      className={classnames('DefaultButton', {
        'green': type === 'lets-go'
      }, className)}
      type={mapTypeToAntdType(type)}
    >
      {isTabletOrMobile && mobileChildren ? mobileChildren : children}
    </Button>
  );
}

export default memo(DefaultButton);
export type { Props as DefaultButtonProps };